<template>
  <div class="validation-wrapper" :class="{ darkModePopup: darkModeClass }">
    <div class="validation-row mb-[10px]">Your password must have</div>
    <div class="mb-[14px]">
      <div>
        <ul class="flex flex-col gap-2">
          <li :class="{ checked: isAtLeast8 }" class="validation">
            <i :class="{ checkedIcon: isAtLeast8 }">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="path1"
                  d="M0.270833 6C0.270833 2.8402 2.8402 0.270833 6 0.270833C9.1598 0.270833 11.7292 2.8402 11.7292 6C11.7292 9.1598 9.1598 11.7292 6 11.7292C2.8402 11.7292 0.270833 9.1598 0.270833 6Z"
                  stroke="#596780"
                  stroke-width="0.541667"
                />
                <path
                  id="path2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.90137 3.97738C9.04668 4.12269 9.04668 4.36176 8.90137 4.50707L5.38574 8.02269C5.31309 8.09535 5.21699 8.13285 5.1209 8.13285C5.0248 8.13285 4.92871 8.09535 4.85605 8.02269L3.09824 6.26488C2.95293 6.11957 2.95293 5.88051 3.09824 5.73519C3.24355 5.58988 3.48262 5.58988 3.62793 5.73519L5.1209 7.22816L8.37168 3.97738C8.51699 3.82972 8.75605 3.82972 8.90137 3.97738Z"
                  fill="#596780"
                />
              </svg>
            </i>

            <span :class="{ validation__text: isAtLeast8 }"
              >8 to 18 characters</span
            >
          </li>
          <li :class="{ checked: isCase }" class="validation">
            <i :class="{ checkedIcon: isCase }">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="path1"
                  d="M0.270833 6C0.270833 2.8402 2.8402 0.270833 6 0.270833C9.1598 0.270833 11.7292 2.8402 11.7292 6C11.7292 9.1598 9.1598 11.7292 6 11.7292C2.8402 11.7292 0.270833 9.1598 0.270833 6Z"
                  stroke="#596780"
                  stroke-width="0.541667"
                />
                <path
                  id="path2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.90137 3.97738C9.04668 4.12269 9.04668 4.36176 8.90137 4.50707L5.38574 8.02269C5.31309 8.09535 5.21699 8.13285 5.1209 8.13285C5.0248 8.13285 4.92871 8.09535 4.85605 8.02269L3.09824 6.26488C2.95293 6.11957 2.95293 5.88051 3.09824 5.73519C3.24355 5.58988 3.48262 5.58988 3.62793 5.73519L5.1209 7.22816L8.37168 3.97738C8.51699 3.82972 8.75605 3.82972 8.90137 3.97738Z"
                  fill="#596780"
                />
              </svg>
            </i>
            <span :class="{ validation__text: isCase }"
              >Upper & lowercase letters</span
            >
          </li>
          <li :class="{ checked: isNumber }" class="validation">
            <i :class="{ checkedIcon: isNumber }">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="path1"
                  d="M0.270833 6C0.270833 2.8402 2.8402 0.270833 6 0.270833C9.1598 0.270833 11.7292 2.8402 11.7292 6C11.7292 9.1598 9.1598 11.7292 6 11.7292C2.8402 11.7292 0.270833 9.1598 0.270833 6Z"
                  stroke="#596780"
                  stroke-width="0.541667"
                />
                <path
                  id="path2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.90137 3.97738C9.04668 4.12269 9.04668 4.36176 8.90137 4.50707L5.38574 8.02269C5.31309 8.09535 5.21699 8.13285 5.1209 8.13285C5.0248 8.13285 4.92871 8.09535 4.85605 8.02269L3.09824 6.26488C2.95293 6.11957 2.95293 5.88051 3.09824 5.73519C3.24355 5.58988 3.48262 5.58988 3.62793 5.73519L5.1209 7.22816L8.37168 3.97738C8.51699 3.82972 8.75605 3.82972 8.90137 3.97738Z"
                  fill="#596780"
                />
              </svg>
            </i>
            <span :class="{ validation__text: isNumber }"
              >At least one number</span
            >
          </li>
          <li :class="{ checked: isSpecial }" class="validation">
            <i :class="{ checkedIcon: isSpecial }">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="path1"
                  d="M0.270833 6C0.270833 2.8402 2.8402 0.270833 6 0.270833C9.1598 0.270833 11.7292 2.8402 11.7292 6C11.7292 9.1598 9.1598 11.7292 6 11.7292C2.8402 11.7292 0.270833 9.1598 0.270833 6Z"
                  stroke="#596780"
                  stroke-width="0.541667"
                />
                <path
                  id="path2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.90137 3.97738C9.04668 4.12269 9.04668 4.36176 8.90137 4.50707L5.38574 8.02269C5.31309 8.09535 5.21699 8.13285 5.1209 8.13285C5.0248 8.13285 4.92871 8.09535 4.85605 8.02269L3.09824 6.26488C2.95293 6.11957 2.95293 5.88051 3.09824 5.73519C3.24355 5.58988 3.48262 5.58988 3.62793 5.73519L5.1209 7.22816L8.37168 3.97738C8.51699 3.82972 8.75605 3.82972 8.90137 3.97738Z"
                  fill="#596780"
                />
              </svg>
            </i>
            <span :class="{ validation__text: isSpecial }"
              >One special character</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="validation-row mb-1">
      Strength:
      <span
        class="text-xs"
        :class="{
          initial: isInitial,
          short: isShort,
          weak: isWeak,
          fair: isFair,
          excellent: isExcellent,
        }"
        >{{ passwordStregnth }}</span
      >
    </div>
    <div class="rg-bar mb-[11px]">
      <div
        :class="{
          highlight: true,
          initial: isInitial,
          bgShort: isShort,
          bgWeak: isWeak,
          bgFair: isFair,
          bgExcellent: isExcellent,
        }"
      ></div>
    </div>
    <span class="text-xs text-secondary-400">
      Avoid using a password that you use with other websites or that might be
      easy for someone else to guess.
    </span>
  </div>
</template>
<script>
export default {
  name: "PasswordValidationPopup",
  props: { password: String, darkModeClass: Boolean },
  data() {
    return {};
  },
  computed: {
    isAtLeast8() {
      return this.password.length >= 8 && this.password.length <= 18;
    },
    isCapital() {
      const regex = /[A-Z]/g;
      return this.password.match(regex);
    },
    isCase() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])/;
      return this.password.match(regex);
    },
    isNumber() {
      const regex = /\d/g;
      return this.password.match(regex);
    },
    isInitial() {
      return this.password.length < 3;
    },
    isShort() {
      return this.password.length >= 3 && !this.isAtLeast8;
    },
    isWeak() {
      return this.isAtLeast8 && (!this.isSpecial || !this.isCapital);
    },
    isFair() {
      return (
        this.isAtLeast8 && this.isCapital && this.isSpecial && this.isNumber
      );
    },
    isExcellent() {
      return (
        this.password.length >= 12 &&
        this.isCapital &&
        this.isSpecial &&
        this.isNumber
      );
    },
    isSpecial() {
      const regex = /[^A-Za-z0-9çğıöşüÇĞİÖŞÜ]/g;
      return this.password.match(regex);
    },
    passwordStregnth() {
      let msg = "";
      msg = this.isShort ? "Very Weak" : msg;
      msg = this.isWeak ? "Weak" : msg;
      msg = this.isFair ? "Fair" : msg;
      msg = this.isExcellent ? "Strong" : msg;
      return msg;
    },
  },
  methods: {},
};
</script>
<style lang="css">
@import "index.module.css";
.short {
  color: #ff4136;
}
.weak {
  color: orange;
}
.fair {
  color: deepskyblue;
}
.excellent {
  color: limegreen;
}
.rg-bar {
  background-color: #90a3bf;
  width: 100%;
  margin-top: 10px;
  height: 3px;
  border-radius: 2px;
}
.highlight {
  height: 100%;
  transition: 0.5s;
  width: 5%;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.bgShort {
  background-color: #ff4136;
  width: 15%;
}
.bgWeak {
  background-color: orange;
  width: 40%;
}
.bgFair {
  background-color: deepskyblue;
  width: 60%;
}
.bgExcellent {
  background-color: limegreen;
  width: 100%;
}
</style>
